import { Injectable, Inject } from '@angular/core'
import { setAngularJSGlobal, UpgradeModule } from '@angular/upgrade/static'
import type angular from 'angular'
import { BootstrapData } from 'elements-sdk'
import { Subject } from 'rxjs'
import { BOOTSTRAP_DATA } from 'api/providers'

@Injectable()
export class LazyLoaderService {
  loaded$ = new Subject<angular.auto.IInjectorService>()
  private app: angular.auto.IInjectorService | undefined

  constructor (
    @Inject(BOOTSTRAP_DATA) private bootstrapData: BootstrapData,
    private upgrade: UpgradeModule,
  ) {}

  async load (setupHook?: CallableFunction): Promise<angular.auto.IInjectorService> {
    if (!this.app) {
      const ng1 = await import('angular')
      const mod = await import('../../app')
      mod.setupNG1(this.bootstrapData, setupHook)
      setAngularJSGlobal(ng1)
      this.upgrade.bootstrap(
        document.querySelector('.angular-js-container')!,
        ['app'],
      )
      this.app = this.upgrade.$injector
      this.loaded$.next(this.upgrade.$injector)
    }
    return this.app as any
  }

  destroy (): void {
    this.app?.get('$rootScope').$destroy()
  }
}
